/// <amd-module name="Artifacts/Package/components/package-details-common/PackageDevelopment" />
import { PackageAttribute } from "Artifacts/Package/components/package-details-common/PackageAttribute";
import { PackageUpstreamSource } from "Artifacts/Package/components/package-details-common/PackageUpstreamSource";
import * as PackageRes from "Artifacts/Package/Resources";
import { CustomerIntelligenceHelper } from "Artifacts/Root/helpers/CustomerIntelligenceHelper";
import { isSafeProtocol } from "Artifacts/Root/helpers/UrlHelper";
import { UpstreamSourceIdentifier } from "Artifacts/Root/types/AzureArtifacts";
import { IMinimalPackageVersion } from "Artifacts/Root/types/IMinimalPackageVersion";
import { IPackage } from "Artifacts/Root/types/IPackage";
import * as React from "react";
import * as StringUtils from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";
import { Icon } from "VSSUI/Icon";
import { Link } from "VSSUI/Link";

export interface IPackageDevelopmentProps {
  pageContext: IVssPageContext;
  /**
   * Project attributes specified by each protocol
   */
  projectAttributes: IProjectAttribute[];
  /**
   * Selected package
   */
  packageSummary: IPackage;
  /**
   * Selected package version
   */
  packageVersion: IMinimalPackageVersion;
  /**
   * List of all upstream sources.
   */
  upstreamSources?: UpstreamSourceIdentifier[];
}

export interface IProjectAttribute {
  iconClass: string;
  url?: string;
  onClickCiFeature?: string;
  text: string;
}

export class PackageDevelopment extends React.PureComponent<IPackageDevelopmentProps> {
  public render(): JSX.Element | null {
    if (!this.showDevelopment()) {
      return null;
    }

    const showProject = this.props.projectAttributes && this.props.projectAttributes.length > 0;
    const showSource = this.props.upstreamSources;
    return (
      <div>
        {(showProject || showSource) && (
          <PackageAttribute
            title={PackageRes.PackageAttributeTitle_Development}
            className="package-development"
          >
            {showSource && (
              <div>
                <div className="package-group-header" role="heading" aria-level={3}>
                  {PackageRes.PackageSource}
                </div>
                <div className="package-attribute-item">
                  <Icon className="package-attribute-item-icon" iconName="Package" />
                  <PackageUpstreamSource
                    pageContext={this.props.pageContext}
                    packageSummary={this.props.packageSummary}
                    packageVersion={this.props.packageVersion}
                    upstreamSources={this.props.upstreamSources}
                  />
                </div>
              </div>
            )}
            {showProject && (
              <div>
                <div className="package-group-spacer" />
                <div className="package-group-header" role="heading" aria-level={3}>
                  {PackageRes.PackageDevelopment_ProjectTitle}
                </div>
                {this.props.projectAttributes.map(
                  (projectAttribute: IProjectAttribute, index: number) => {
                    return (
                      <div className="package-attribute-item" key={index}>
                        <Icon
                          className="package-attribute-item-icon"
                          iconName={projectAttribute.iconClass}
                        />
                        {isSafeProtocol(projectAttribute.url || "") ? (
                          <Link
                            href={projectAttribute.url}
                            ariaLabel={StringUtils.format(
                              "{0}: {1}",
                              projectAttribute.text,
                              projectAttribute.url,
                            )}
                            onClick={() =>
                              projectAttribute.onClickCiFeature &&
                              CustomerIntelligenceHelper.publishEvent(
                                this.props.pageContext,
                                projectAttribute.onClickCiFeature,
                              )
                            }
                          >
                            {projectAttribute.text}
                            <Icon iconName="NavigateExternalInline" />
                          </Link>
                        ) : (
                          <div className="project-attibute-text">{projectAttribute.text}</div>
                        )}
                      </div>
                    );
                  },
                )}
              </div>
            )}
          </PackageAttribute>
        )}
      </div>
    );
  }

  private showDevelopment(): boolean {
    return (
      this.props.upstreamSources != null ||
      (this.props.projectAttributes && this.props.projectAttributes.length > 0)
    );
  }
}
